import { Component } from '@angular/core';
import { ButtonComponent } from '../../shared/button/button.component';
import { ModalComponent } from '../../shared/modal/modal.component';
import { ModalService } from '../../shared/modal/modal.service';

@Component({
  selector: 'app-termos-privacidade',
  standalone: true,
  imports: [ButtonComponent, ModalComponent],
  templateUrl: './termos-privacidade.component.html',
  styleUrl: './termos-privacidade.component.scss',
})
export class TermosPrivacidadeComponent {
  email: string = 'atendimento@escolarai.com';

  constructor(private readonly modalService: ModalService) {}

  fechar() {
    this.modalService.close();
  }
}
